import React, { FC, useContext, Fragment, useState, useRef, useEffect } from "react";

import { Dialog, Transition } from '@headlessui/react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { customGlobeSvgIcon } from '../customIcons/customGlobe'

interface InkomenscategorieInterface {
  open: boolean,
  setOpen: any,
  setIncomeCategory: any,
  setEnergyOpen: any
}

const Inkomenscategorie: FC<InkomenscategorieInterface> = (props) => {
  const cancelButtonRef = useRef(null)

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const data: Record<string, string> = {};
    formData.forEach((value, key) => {
      data[key] = value.toString();
    });
    let incomeCategory = data.incomeCategory;

    let incomeSplitted = incomeCategory.split("-")
    if (Number(incomeSplitted[0]) === 1) {
      props.setOpen(false)
      window.location.href = "https://energiehuislimburg.be/aanvraag-mijnverbouwbegeleiding/"
    } else {
      props.setIncomeCategory(incomeCategory)
      props.setEnergyOpen(true)
      props.setOpen(false)
    }

  }

  return (
    <Transition.Root show={props.open} as={Fragment}>
      <Dialog as="div" className="relative z-50" initialFocus={cancelButtonRef} onClose={props.setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <form className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full  sm:w-full md:max-w-2xl" onSubmit={handleSubmit}>
                <Dialog.Panel className="">

                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="">

                      <div className="mt-3 text-center sm:mt-0  sm:text-left">
                        <Dialog.Title as="h1" className="text-2xl md:text-2xl xl:text-2xl  2xl:text-4xl font-bold border-l-8	border-hasselt pl-2">
                          {"Inkomenscategorie"}
                        </Dialog.Title>


                        <div className="mt-2">
                          <div className="mt-[33px] text-black font-barlow text-base not-italic font-normal leading-none">Om te bepalen of je in aanmerking komt voor extra ondersteuning, hebben we informatie nodig over de inkomenscategorie van je gezin. Deze gegevens worden enkel gebruikt voor de evaluatie van je aanvraag.</div>

                          <div className="mt-[32px]">
                            <label className="block md:text-base xl:text-base 2xl:text-base font-semibold text-gray-900 mb-[2px]">
                              Welke inkomenscategorie?
                            </label>
                            <p className="text-gray-700 text-base mb-[18px] ml-[0px]">
                              Meer info op deze
                              <a
                                href="https://www.vlaanderen.be/premies-voor-renovatie/mijn-verbouwpremie/wie-kan-mijn-verbouwpremie-aanvragen#eigenaar-bewoner-per-inkomenscategorie"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#4C8183] hover:underline ml-1 inline-flex items-center"
                              >
                                link
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-3 w-3 mt-1"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  stroke-width="2"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M14 3h7m0 0v7m0-7L10 14"
                                  />
                                </svg>
                              </a>
                            </p>
                            <div className="flex flex-col gap-1 mb-[30px]">
                              {[
                                "1-Familie inkomen minder dan 53.880 €",
                                "2-Familie inkomen meer dan 53.800 €",
                              ].map((value, idx) => (
                                <label
                                  key={value}
                                  className="inline-flex items-center pr-1 py-1  cursor-pointer"
                                >
                                  <input
                                    className="hover:bg-[#00736A] hover:accent-[#00736A] transition-colors duration-200"
                                    type="radio"
                                    name="incomeCategory"
                                    value={value}
                                    id={value}
                                    defaultChecked={idx === 0}
                                    required
                                    style={{
                                      accentColor: "#00736A",
                                      width: "20px",
                                      height: "20px",
                                    }}
                                  />
                                  <span className="ml-2">{value.split("-")[1]}</span>
                                </label>
                              ))}
                            </div>
                            <p className="text-gray-700 text-base mb-[18px] ml-[0px]">
                              <strong>Opgelet:</strong> Als het gezamenlijk gezinsinkomen lager is dan €53.880, dan word je automatisch doorverwezen naar <a
                                href="https://energiehuislimburg.be/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#4C8183] hover:underline ml-1 inline-flex items-center"
                              >
                                energiehuislimburg.be
                              </a> Zij zullen je verder begeleiden in jouw renovatietraject.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">

                    <button
                      type="submit"
                      className="inline-flex m-1 justify-center rounded-md border border-transparent bg-hasselt text-white hover:bg-hasselt-dark focus:ring-4 focus:outline-none focus:ring-hasselt-accent font-medium rounded-lg text-sm px-5 py-2.5 text-center content-end"
                    // onClick={() => props.setOpen(false)}
                    >
                      Volgende
                    </button>
                    <button
                      type="button"
                      className="inline-flex m-1 justify-center rounded-md border border-black bg-white text-baclk hover:bg-black hover:text-white focus:ring-4 focus:outline-none focus:ring-hasselt-accent font-medium rounded-lg text-sm px-5 py-2.5 text-center content-end "
                      onClick={() => { props.setOpen(false) }}
                    >
                      Sluiten
                    </button>

                  </div>
                </Dialog.Panel>
              </form>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Inkomenscategorie;
